import React, { useEffect, useState } from 'react';
import UsersRequests from 'services/users';
import { useDispatch, useSelector } from 'react-redux';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import GridContainer from '@jumbo/components/GridContainer';

import CmtCard from '@coremat/CmtCard';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import AddedUsers from './AddedUsers';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    paddingTop: '24px',
    [theme.breakpoints.down('xs')]: {
      '& .Cmt-header-root': {
        flexDirection: 'column',
      },
      '& .Cmt-action-default-menu': {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  formContainer: {
    width: '100%',
  },
  girdContainer: {
    width: '100%',
    margin: '0',
    padding: '0',
  },
  customInput: {
    width: '80%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  inputContainer: {
    paddingInline: '40px !important',
    '& p': {
      fontWeight: 'bold',
      marginBottom: '16px',
    },
  },
}));

const AddUser = () => {
  const [userName, setUserName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [passWord, setPassWord] = useState('');
  const classes = useStyles();
  const dispatch = useDispatch();
  const { registeredUsers } = useSelector(({ users }) => users);

  useEffect(() => {
    setUserName('');
    setPhoneNumber('');
    setPassWord('');
  }, [registeredUsers.length]);

  const handleSubmit = () => {
    if (userName && phoneNumber && passWord) {
      const userdata = {
        name: userName,
        phone: phoneNumber,
        password: passWord,
      };
      dispatch(UsersRequests.registerUser(userdata));
    }
  };

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <form className={classes.formContainer} noValidate autoComplete="off">
          <GridContainer className={classes.girdContainer}>
            <Grid item xs={6} className={classes.inputContainer}>
              <Typography>نام کاربری</Typography>
              <TextField
                id="userNameInput"
                label="نام کاربری"
                variant="outlined"
                className={classes.customInput}
                value={userName}
                onChange={e => setUserName(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} className={classes.inputContainer}>
              <Typography>شماره تلفن</Typography>
              <TextField
                id="phoneInput"
                label="شماره تلفن"
                variant="outlined"
                className={classes.customInput}
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} className={classes.inputContainer}>
              <Typography>رمز عبور</Typography>
              <TextField
                id="password"
                label="رمز عبور"
                variant="outlined"
                className={classes.customInput}
                value={passWord}
                onChange={e => setPassWord(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <Button variant="contained" color="primary" size="large" startIcon={<SaveIcon />} onClick={handleSubmit}>
                ذخیره
              </Button>
            </Grid>
          </GridContainer>
        </form>
        <GridContainer className={classes.girdContainer} justifyContent="center">
          {registeredUsers.map((user, index) => (
            <Grid item xs={6}>
              <AddedUsers addedUser={user} key={index} />
            </Grid>
          ))}
        </GridContainer>
      </CmtCardContent>
    </CmtCard>
  );
};

export default AddUser;
